import { Box, Grid2, Tab } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader";
import { MenuContext } from "../../../App";
import { CreateHandleUnsaveNavigation } from "../../../utilities/handleUnsaveNavigation";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import PersonIcon from "@mui/icons-material/Person";
import style from "./Subject.module.css";
import {
  getPatientDiaryDetailsService,
  getPatientVisitDataService,
  getSubjectDetailsByIdService,
} from "../../../services/subjectService";
import {
  formatDateWithoutTime,
  validDateRegex,
} from "../../../utilities/helper";
import SubjectVisitManagement from "./SubjectVisitManagement/SubjectVisitManagement";

const UpdateSubject = () => {
  const id = useLocation()?.state?.id;

  console.log("ID in UpdateSubject:", id);

  const [load, setLoad] = useState(false);

  const [canUpdateSubject, setCanUpdateSubject] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);

  const [tabValue, setTabValue] = useState("subjectManagement");
  const [subjectDetails, setSubjectDetails] = useState({
    subjectName: "",
    status: "",
    attributes: [],
  });

  const [visitData, setVisitData] = useState([]);

  const navigate = useNavigate();

  const { systemActions } = useContext(MenuContext);
  const handleUnsaveNavigation = CreateHandleUnsaveNavigation();
  const cultureCode = localStorage.getItem("currentUserCultureCode");
  const userId = localStorage.getItem("roleId");

  const { attributes, subjectName, status } = subjectDetails;

  const access_token = localStorage.getItem("access_token");
  const role = localStorage.getItem("role");

  useEffect(() => {
    if (id) {
      getSubjectDetails(id);
    }
  }, [id]);

  useEffect(() => {
    if (systemActions?.length > 0 && role !== "Admin" && id) {
      let canUpdate = false;
      const updateFound = systemActions?.find(
        (item) => item?.name === "CanEditPatient"
      );
      if (updateFound) {
        canUpdate = true;
      }
      setCanUpdateSubject(canUpdate);
    } else {
      if (!id || role === "Admin") {
        setCanUpdateSubject(true);
      }
    }
  }, [systemActions, id]);

  useEffect(() => {
    if (canUpdateSubject) {
      setIsReadOnly(false);
    } else {
      setIsReadOnly(true);
    }
  }, [canUpdateSubject]);

  useEffect(() => {
    if (tabValue === "visits" && id) {
      getPatientVisitData(id);
    }
  }, [tabValue, id]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const getSubjectDetails = async (id) => {
    try {
      setLoad(true);
      const res = await getSubjectDetailsByIdService(
        access_token,
        id,
        cultureCode,
        []
      );
      if (res?.status == 200 && res?.data?.status === "OK") {
        const patientData = res?.data?.result?.patientData;
        setSubjectDetails({
          subjectName: patientData?.patientNumber || "",
          status: patientData?.patientStatus || "",
          attributes: patientData?.attributes || [],
        });
      }
    } catch (err) {
      console.log("Error fetching subject details:", err);
    } finally {
      setLoad(false);
    }
  };

  const getPatientVisitData = async (patientId) => {
    try {
      setLoad(true);
      const res = await getPatientVisitDataService(access_token, patientId);
      if (res?.data?.status === "200") {
        setVisitData(res?.data?.result || []);
      }
    } catch (err) {
      console.log("Error:", err?.message);
      if (err?.status === 401) {
        navigate("/unAuhthorized");
      }
    } finally {
      setLoad(false);
    }
  };

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className="content-body">
          <p className="bread-crumbs-link-container">
            <button className="bread-crumbs-btn" onClick={(e) => navigate("/")}>
              Home
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) => navigate("/subject")}
            >
              Subject Management
            </button>{" "}
            |{" "}
            <button className="bread-crumbs-btn" to="/update-subject">
              {subjectName}
            </button>
            -{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>

          {/* Tab Section */}
          <Box sx={{ width: "100%", typography: "body1", marginTop: "2%" }}>
            <TabContext value={tabValue}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleTabChange}
                  aria-label="Site Tabs"
                  TabIndicatorProps={{ style: { display: "none" } }}
                  sx={{
                    "& .MuiTab-root": {
                      textTransform: "none",
                      wordSpacing: "-2px",
                      fontWeight: 500,
                      borderRadius: "999px",
                      minHeight: "40px",
                      px: 3,
                      py: 1,
                      mx: 0.5,
                      // mt: 2,
                      transition: "all 0.3s ease",
                      color: "text.secondary",
                      bgcolor: "transparent",
                    },
                    "& .Mui-selected": {
                      bgcolor: "primary.main",
                      color: "white !important",
                      boxShadow: 2,
                    },
                  }}
                >
                  <Tab label="Subject Management" value="subjectManagement" />
                  <Tab label="Visits" value="visits" />
                </TabList>
              </Box>
              <TabPanel value="subjectManagement" sx={{ padding: "30px 0px" }}>
                {/* Subject Management */}
                <>
                  <div className="subject-name-container">
                    <PersonIcon sx={{ fontSize: "50px", color: "black" }} />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span>{subjectName}</span>
                      <span className="subject-id">{status}</span>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "30px",
                      justifyContent: "space-between",
                      alignContent: "center",
                      padding: "0 30px",
                    }}
                  >
                    <button
                      className="create-btn-outlined big-btn"
                      onClick={() =>
                        navigate("/subject-data-correction", {
                          state: {
                            id: id,
                          },
                        })
                      }
                    >
                      Data Correction
                    </button>
                    <button
                      className="create-btn-outlined big-btn"
                      onClick={() =>
                        navigate("/unblind-subject", { state: { id: id } })
                      }
                    >
                      Unblind Subject
                    </button>
                    <button
                      title="Register Randomization or Treatment error"
                      className="create-btn-outlined big-btn"
                      onClick={() =>
                        navigate("/subject-randomization-treatment", {
                          state: {
                            id: id,
                          },
                        })
                      }
                    >
                      Register Randomization or Treatment error
                    </button>
                    <button
                      className="create-btn-outlined big-btn"
                      onClick={() => {
                        navigate("/subject-test", {
                          state: {
                            id: id,
                          },
                        });
                      }}
                    >
                      Test
                    </button>
                  </div>
                  {attributes && attributes.length > 0 && (
                    <div className={style?.subjectDetailMainContainer}>
                      {attributes?.map((item) => (
                        <div
                          className={style?.subjectDetailOuterContainer}
                          key={item?.keyName}
                        >
                          <span className={style?.subjectDetailName}>
                            {item?.label}
                          </span>
                          <span className={style?.subjectDetailValue}>
                            {validDateRegex.test(item?.value)
                              ? formatDateWithoutTime(item?.value)
                              : item?.value}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              </TabPanel>
              <TabPanel value="visits" sx={{ padding: "30px 0px" }}>
                <Grid2
                  container
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ width: "100%", margin: "0 auto", marginTop: "-2%" }}
                >
                  <Grid2 item md={12}>
                    <p className="page-heading">Subject Visits</p>
                  </Grid2>
                </Grid2>
                {visitData && visitData.length > 0 ? (
                  visitData.map((visitItem) => (
                    <SubjectVisitManagement
                      key={visitItem?.id}
                      data={visitItem}
                    />
                  ))
                ) : (
                  <p>No visits available for this subject.</p>
                )}
              </TabPanel>
            </TabContext>
          </Box>
        </div>
      )}
    </>
  );
};

export default UpdateSubject;
